// core version + navigation, pagination modules:
// import Swiper, {A11y, Autoplay, EffectFade, Lazy, Navigation, Pagination} from 'swiper';
// import flatpickr from 'flatpickr';
// import rangePlugin from 'flatpickr/dist/plugins/rangePlugin';

export default {
  finalize() {
    // breakpoint where swiper will be destroyed
    // and switches to a dual-column layout
    const breakpoint = window.matchMedia('(min-width:768px)');

    /* global Swiper */
    // keep track of swiper instances to destroy later
    const enableSwiper = function () {
      if (window.gallery !== undefined) {
        window.gallery.destroy(true, true);
      }
      if (breakpoint.matches) {
        // init slideshows
        console.log('Enabling Swiper');
        // Swiper.use([Navigation, Pagination, EffectFade, Lazy, Autoplay, A11y]);
        window.gallery = new Swiper('.swiper-accommodation-container', {
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
          },
          autoplay: {
            delay: 5000,
          },
          lazyLoading: true,
          lazy: {
            loadPrevNext: true,
          },
          resizeObserver: true,
        });
      }
    };

    const breakpointChecker = function () {
      enableSwiper();
      if (breakpoint.matches) {
        initPicker();
      } else {
        initPickerModal();
      }
    }

    breakpoint.addEventListener('change', breakpointChecker);
    breakpointChecker(breakpoint);

    window.addEventListener('resize', breakpointChecker);

    /* global flatpickr, rangePlugin, locale */
    let bookingDates;

    function initPicker() {
      bookingDates = flatpickr('#checkin', {
        mode: 'range',
        minDate: 'today',
        locale: locale.current,
        formatDate: dateObj => dateObj.toLocaleDateString(locale.current),
        'plugins': [new rangePlugin({input: '#checkout'})],
      });
    }

    function initPickerModal() {
      bookingDates = flatpickr('#checkin-mobile', {
        mode: 'range',
        minDate: 'today',
        locale: locale.current,
        formatDate: dateObj => dateObj.toLocaleDateString(locale.current),
        'plugins': [new rangePlugin({input: '#checkout-mobile'})],
      });
    }

    const getActiveWrapper = function () {
      return breakpoint.matches ? 'booking-widget' : 'booking-widget-mobile';
    };

    const buildBookingUrl = function (wrapper) {
      const checkin = bookingDates.selectedDates[0] ? bookingDates.selectedDates[0].yyyymmdd() : null;
      const checkout = bookingDates.selectedDates[1] ? bookingDates.selectedDates[1].yyyymmdd() : null;

      if (!checkin || !checkout) {
        return '/';
      }

      const adults = parseInt(document.querySelector('#' + wrapper + ' #adults').value);
      const children = parseInt(document.querySelector('#' + wrapper + ' #children').value);
      const childrenage = document.querySelectorAll('#' + wrapper + ' [name="childrenage[]"]');
      let ages = '';
      if (childrenage.length > 0) {
        ages = '&ages=';
        for (let i = 0; i < childrenage.length; i++) {
          ages += childrenage[i].value + ',';
        }
        ages = ages.slice(0, -1);
      }

      let baseErmesUrl = locale.ermes_base_url;
      return baseErmesUrl + 'arrival=' + checkin + '&departure=' + checkout + '&adults=' + adults + '&childs=' + children + ages;
    };

    window.bookingWidget = window.bookingWidget || {};
    window.bookingWidget.urlFormUpdated = function (form, url) {
      if (!form || typeof url !== 'string' || !url.length) {
        return;
      }
      form.setAttribute('action', url);
    };

    window.bookingWidget.updateUrlForm = function (form, wrapper) {
      const targetWrapper = wrapper || getActiveWrapper();
      const targetForm = form || document.querySelector('#' + targetWrapper + ' form.booking');
      const url = buildBookingUrl(targetWrapper);
      window.bookingWidget.urlFormUpdated(targetForm, url);
      return url;
    };

    window.bookingWidget.submit = function () {
      const wrapper = getActiveWrapper();
      const form = document.querySelector('#' + wrapper + ' form.booking');
      if (form) {
        form.requestSubmit();
      }
    };

    const bookingForms = document.querySelectorAll('#booking-widget form.booking, #booking-widget-mobile form.booking');
    bookingForms.forEach(form => {
      const wrapperNode = form.closest('[id]');
      if (!wrapperNode) {
        return;
      }

      const wrapper = wrapperNode.id;

      form.addEventListener('input', function () {
        window.bookingWidget.updateUrlForm(form, wrapper);
      });

      form.addEventListener('change', function () {
        window.bookingWidget.updateUrlForm(form, wrapper);
      });

      form.addEventListener('submit', function (event) {
        if (bookingDates.selectedDates[0] === undefined || bookingDates.selectedDates[1] === undefined) {
          event.preventDefault();
          alert(locale.please_select_dates);
          return;
        }

        window.bookingWidget.updateUrlForm(form, wrapper);
        const namedFields = form.querySelectorAll('input[name], select[name], textarea[name], button[name]');
        namedFields.forEach(field => {
          field.disabled = true;
        });
      });

      window.bookingWidget.updateUrlForm(form, wrapper);
    });
  },
};
